// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ActionBox_checkbox__3lNMz","delete":"ActionBox_delete__2rWwA"};